import React, { Component } from 'react'
import Helmet from 'react-helmet'
import { HelmetDatoCms } from 'gatsby-source-datocms'
import Link from 'gatsby-link'
import PropTypes from 'prop-types'

import Img from 'gatsby-image'

import Header from '../components/Header'
import Footer from '../components/Footer'

import normalize from 'normalize.css'
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import '../assets/stylesheets/application.sass'

require("typeface-lato")
require("typeface-montserrat")

const locales = ["en", "it"]

class Layout extends Component {
  render() {
    let { children, data } = this.props
    let path_splits = this.props.location.pathname.split("/");
    let locale = "en";
    let incipit = path_splits[1];
    if (locales.indexOf(incipit) > -1) {
      locale = incipit;
    }
    let prefix = locale === "en" ? "" : locale;
    let pathLength = path_splits.length

    return(
      <div>
        <HelmetDatoCms favicon={data.datoCmsSite.faviconMetaTags} />
        <HelmetDatoCms seo={data.homepage.seoMetaTags} />
        <Helmet>
          <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no" />
          <meta name="google-site-verification" content="Yrwli9ayg-S6siWtt6QlX_cF_sEdWZa0CmiL7Tf1_3M" />
          {
            (prefix === "")
            && (
              <script
                type="text/javascript">{`
                  {
                  var _iub = _iub || [];
                  _iub.csConfiguration = {"lang":"en","siteId":1277293,"cookiePolicyId":53054619};
                  }
                `}
              </script>
            )
          }
          {
            (prefix === "it")
            && (
              <script
                type="text/javascript">{`
                  {
                  var _iub = _iub || [];
                  _iub.csConfiguration = {"lang":"it","siteId":1277293,"cookiePolicyId":53054619};
                  }
                `}
              </script>
            )
          }
          <script type="text/javascript" src="//cdn.iubenda.com/cookie_solution/safemode/iubenda_cs.js" charset="UTF-8" async></script>
        </Helmet>
        <Header
          language={ prefix }
          length = { pathLength }
          logoBlue={ data.homepage.logoBlue }
          logo={ data.homepage.logo }
        />
        { children() }
        <Footer
          language={ prefix }
          logo={ data.homepage.logo }
          houses={ data.houses.edges }
          footer={ data.homepage.footer }
        />
      </div>
    )
  }
}

Layout.propTypes = {
  children: PropTypes.func,
}

export default Layout

export const query = graphql`
  query Logo {
    datoCmsSite {
      faviconMetaTags {
        ...GatsbyDatoCmsFaviconMetaTags
      }
    }
    datoCmsSeoMetaTags {
      ...GatsbyDatoCmsSeoMetaTags
    }
    homepage:  datoCmsHomepage {
      logo {
        sizes(maxWidth: 300) {
          ...GatsbyDatoCmsSizes
        }
      }
      seoMetaTags {
        ...GatsbyDatoCmsSeoMetaTags
      }
      footer
      logoBlue {
        id
        sizes(maxWidth: 300) {
          ...GatsbyDatoCmsSizes
        }
      }
    }
    houses: allDatoCmsHouse {
      edges {
        node {
          id
          name
          locale
          slug
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/layouts/index.js